import React, { useState } from "react";
import { ChatCircleText, ClockCounterClockwise, NoteBlank } from "@phosphor-icons/react";
import { LabChatTab } from "./LabChatTab";
import { TimelineTab } from "./TimelineTab";
import { NotesTab } from "./NotesTab";

/**
 * Activity Tab — Lab Chat + Timeline + Internal Notes.
 *
 * iter101.14 · Phase 3 — swapped the dark-filled-pill switcher for the
 * doctor portal's `border-b-2 border-primary` underline pattern so the
 * admin case page reads as one product across every tab.
 * iter101.92 · Added the third "Notes" sub-tab — internal admin notes
 * used to live in a right-sidebar widget on Overview but were pure
 * noise there (empty in 90%+ of cases). Moved here alongside the
 * existing lab chat + timeline so all activity/log surfaces are in
 * one place. Uses the standalone `NotesTab` composer (previously an
 * orphan file, now wired in).
 */
export function ActivityTab({ c, reload }) {
    const [view, setView] = useState("chat");

    const subTab = (key, label, Icon) => {
        const isActive = view === key;
        return (
            <button
                key={key}
                onClick={() => setView(key)}
                className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors flex items-center gap-1.5 ${
                    isActive
                        ? "border-primary text-primary"
                        : "border-transparent text-muted-foreground hover:text-foreground"
                }`}
                data-testid={`activity-switch-${key}`}
            >
                <Icon size={14} weight={isActive ? "fill" : "duotone"} />
                {label}
            </button>
        );
    };

    return (
        <div className="space-y-4" data-testid="activity-tab">
            <div className="flex items-center gap-1 border-b border-border overflow-x-auto">
                {subTab("chat", "Lab Chat", ChatCircleText)}
                {subTab("timeline", "Timeline", ClockCounterClockwise)}
                {subTab("notes", "Notes", NoteBlank)}
            </div>

            {view === "chat" && <LabChatTab c={c} />}
            {view === "timeline" && <TimelineTab c={c} />}
            {view === "notes" && <NotesTab c={c} reloadCase={reload} />}
        </div>
    );
}
